import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
export function CostSection() {
  const costs = [{
    situation: 'Leer 600 páginas de bibliografía por materia',
    cost: '40+ horas por cuatrimestre perdidas'
  }, {
    situation: 'Sin esquemas propios',
    cost: '3 horas extra de estudio por cada tema'
  }, {
    situation: 'Sin método de oral',
    cost: 'Finales aplazados que alargan la carrera'
  }, {
    situation: 'Sin diccionario jurídico',
    cost: 'Clases enteras sin entender el lenguaje'
  }, {
    situation: 'Sin planner de estudio',
    cost: 'Caos académico que genera ansiedad crónica'
  }, {
    situation: 'Sin kit de supervivencia',
    cost: 'Primeras semanas de desorientación total'
  }, {
    situation: 'Sin sistema de excelencia',
    cost: 'Promedios bajos que cierran puertas profesionales'
  }];
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-72">
      <FadeIn data-id="element-73">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-74">
          <span className="text-4xl" data-id="element-75">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden" data-id="element-76">
          <div className="grid grid-cols-2 bg-gray-800/80 border-b border-gray-700 p-4 font-bold" data-id="element-77">
            <div className="text-gray-400" data-id="element-78">Situación actual</div>
            <div className="text-red-400" data-id="element-79">Costo real</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-80">
            {costs.map((item, index) => <div key={index} className="grid grid-cols-2 p-4 items-center hover:bg-gray-800/30 transition-colors" data-id="element-81">
                <div className="text-gray-300 pr-4" data-id="element-82">{item.situation}</div>
                <div className="font-bold text-red-400 flex items-center gap-2" data-id="element-83">
                  <AlertOctagon size={16} className="shrink-0" data-id="element-84" />
                  <span data-id="element-85">{item.cost}</span>
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-center text-gray-400 mt-8 font-medium" data-id="element-86">
          Cada cuatrimestre sin sistema es un cuatrimestre más largo de lo
          necesario.
        </p>
      </FadeIn>
    </section>;
}